<template class="">
  <div class="w-full">
    <div v-if="contrato != undefined">
      <div :class="fadeClass">
        <vs-row vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
          <vs-col
            class="text-white"
            vs-align="center"
            vs-justify="center"
            vs-type="flex"
            vs-w="12"
          >
            <vx-card
              v-if="contrato.devendo > 0"
              :card-background="
                contrato.contrato_parcelas_atrasadas >= 3 ? '#4B0082' : 'danger'
              "
              class="w-full"
              no-shadow
            >
              <vs-row
                vs-align="center"
                vs-justify="center"
                vs-type="flex"
                vs-w="12"
              >
                <vs-col
                  class="text-white"
                  vs-align="center"
                  vs-justify="center"
                  vs-type="flex"
                  vs-w="12"
                >
                  <span class="font-bold font-italic" style="font-size: 12px"
                    >CLIENTE COM PENDÊNCIAS FINANCEIRAS
                  </span>
                  <span
                    v-if="contrato.contrato_parcelas_atrasadas >= 1"
                    class="font-bold font-italic"
                    style="padding-left: 5px; font-size: 12px"
                  >
                    E CONTRATO {{ contrato.id }} COM #{{
                      contrato.contrato_parcelas_atrasadas
                    }}
                    PARCELAS VENCIDAS
                  </span>
                </vs-col>
              </vs-row>
            </vx-card>
          </vs-col>

          <vs-col
            class="text-white"
            vs-align="center"
            vs-justify="center"
            vs-type="flex"
            vs-w="12"
          >
            <vx-card
              :card-background="contrato.id_status == 3 ? 'danger' : 'primary'"
              no-shadow
            >
              <vs-row
                vs-align="center"
                vs-justify="space-between"
                vs-type="flex"
              >
                <vs-col
                  :class="contrato.id_status == 3 ? 'text-white' : 'text-black'"
                  class="pt-2"
                  vs-align="flex-start"
                  vs-justify="flex-start"
                  vs-type="flex"
                  vs-w="9.5"
                >
                  <h6 class="font-bold">
                    {{ empresa_contrato.nome_fantasia }}
                  </h6>
                  <h6
                    :class="
                      contrato.id_status == 3 ? 'text-white' : 'text-black'
                    "
                    class="ml-8 font-weight-bold"
                  >
                    {{ estagio }} {{ tipo_faturamento }}
                    {{
                      contrato.renovacao > 0 && contrato.id_relacional > 0
                        ? " de Renovação "
                        : ""
                    }}
                    Nº.
                    {{ contrato.id }}
                  </h6>
                  <div v-if="contrato.id_estagio == 2">
                    <h6
                      :class="
                        contrato.id_status == 3 ? 'text-white' : 'text-black'
                      "
                      class="ml-8"
                    >
                      Data: {{ contrato.data_proposta | moment("DD/MM/YYYY") }}
                    </h6>
                  </div>
                  <div v-if="contrato.id_estagio == 3">
                    <h6
                      :class="
                        contrato.id_status == 3 ? 'text-white' : 'text-black'
                      "
                      class="ml-8"
                    >
                      Data: {{ contrato.data_contrato | moment("DD/MM/YYYY") }}
                    </h6>
                  </div>
                  <div v-if="contrato.data_vencimento">
                    <h6
                      :class="
                        contrato.id_status == 3 ? 'text-white' : 'text-black'
                      "
                      class="ml-8"
                    >
                      Vencimento:
                      {{ contrato.data_vencimento | moment("DD/MM/YYYY") }}
                    </h6>
                  </div>
                  <div
                    v-if="contrato.data_vencimento && contrato.id_estagio == 3"
                  >
                    <h6
                      :class="
                        contrato.id_status == 3 ? 'text-white' : 'text-black'
                      "
                      class="ml-8"
                    >
                      Valor hora técnica:
                      <span
                        :style="
                          contrato.id_status == 3
                            ? ''
                            : 'color: #008000; font-weight: bold;'
                        "
                      >
                        R$ {{ valorHoraTecnicaCalculada.toFixed(2) }}
                      </span>
                    </h6>
                  </div>
                </vs-col>
                <vs-col
                  v-if="cliente.id"
                  :key="reRender"
                  vs-align="flex-end"
                  vs-justify="flex-end"
                  vs-type="flex"
                  vs-w="2.5"
                >
                  <ModalEditarCliente
                    :botaoEditar="false"
                    :cliente="cliente"
                    :textColor="contrato.id_status == 3 ? 'white' : 'dark'"
                  />
                </vs-col>
              </vs-row>
            </vx-card>
          </vs-col>
        </vs-row>
        <vs-tabs
          v-model="tabs"
          alignment="fixed"
          class="tabs-shadow-none mt-5"
          color="dark"
          position="left"
          id="icons-contrato"
          :key="reRender"
        >
          <!-- <vs-tab
            :disabled="!(contrato.id_estagio > 1)"
            icon="filter_1"
            label="Planos"
            style="height: 500px"
          >
            <VuePerfectScrollbar
              class="scroll-tab-contrato"
              :settings="settings"
            >
              <div class="tab-general w-full">
                <vx-card>
                  <planos
                    @refresh="getContratoRerender()"
                    :empresa="empresa_contrato"
                    :limites_desconto="limites_desconto"
                    :status="status"
                    :cliente="cliente"
                    :contrato="contrato"
                  ></planos>
                </vx-card>
              </div>
            </VuePerfectScrollbar>
          </vs-tab> -->

          <vs-tab
            class="w-full"
            icon="filter_1"
            label="Inf. Tecnica"
            style="height: 500px"
          >
            <VuePerfectScrollbar
              ref="scrollTabTecnica"
              :settings="settings"
              class="scroll-tab-contrato"
            >
              <!-- @ps-scroll-y="onScrollTecnica" -->
              <div class="tab-general w-full" ref="tabTecnicaContent">
                <vx-card class="p-0">
                  <!-- ═══════════════════ HEADER ═══════════════════ -->
                  <div class="inftec-header">
                    <div class="inftec-header-title">
                      <span class="inftec-icon"></span>
                      <h4>Informação Técnica</h4>
                    </div>
                    <SuccessButton
                      :disabled="isInfoTecnicaDisabled"
                      size="small"
                      text="Salvar alterações"
                      @func="update()"
                    ></SuccessButton>
                  </div>

                  <!-- ═══════════════════ SEÇÃO: FORÇA DE TRABALHO ═══════════════════ -->
                  <vs-divider position="center">Força de Trabalho</vs-divider>
                  <div class="pt-2 pb-3">
                    <ForcaTrabalho
                      :contrato="contrato"
                      :disabled="isInfoTecnicaDisabled"
                      :lock-horas-tecnicos="isForcaTrabalhoLockedByLevantamento"
                      :pode-zerar-forca="podeZerarForca"
                      @update="updateContrato"
                    />
                  </div>

                  <!-- ═══════════════════ SEÇÃO: DATAS & PRAZOS ═══════════════════ -->
                  <vs-divider class="py-0 my-0" position="center"
                    >Datas</vs-divider
                  >
                  <div class="pt-4">
                    <div class="inftec-grid-4 px-4">
                      <div class="inftec-field">
                        <label class="">
                          {{
                            contrato.id_estagio == 2
                              ? "Data Proposta"
                              : "Data Contrato"
                          }}
                        </label>
                        <vs-input
                          v-if="contrato.id_estagio == 2"
                          v-model="contrato.data_proposta"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          color="dark"
                          type="date"
                          class="w-full"
                        />
                        <vs-input
                          v-else
                          v-model="contrato.data_contrato"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          color="dark"
                          type="date"
                          class="w-full"
                        />
                      </div>
                      <div class="inftec-field">
                        <label class="">Vencimento</label>
                        <vs-input
                          v-model="contrato.data_vencimento"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          color="dark"
                          type="date"
                          class="w-full"
                        />
                      </div>
                      <div class="inftec-field">
                        <label class="">Garantia</label>
                        <vs-input
                          v-model="contrato.garantia"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          color="dark"
                          icon="MES"
                          icon-after="true"
                          min="1"
                          type="number"
                          class="w-full"
                        />
                      </div>
                      <div class="inftec-field">
                        <label class="">Aplicações</label>
                        <vs-input
                          v-model="contrato.aplicacoes"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          color="dark"
                          icon="QTD"
                          icon-after="true"
                          min="1"
                          type="number"
                          class="w-full"
                        />
                      </div>
                      <div class="inftec-field">
                        <label class="">Dias entre Manutenções</label>
                        <vs-input
                          v-model="contrato.periodo_manutencao"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          color="dark"
                          icon="DIA"
                          icon-after="true"
                          min="1"
                          type="number"
                          class="w-full"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- ═══════════════════ SEÇÃO: CONFIRMAÇÃO ═══════════════════ -->

                  <!-- ═══════════════════ SEÇÃO: DETALHES TÉCNICOS ═══════════════════ -->
                  <vs-divider class="py-0 my-0" position="center"
                    >Detalhes Técnicos</vs-divider
                  >
                  <div class="pt-4">
                    <div class="inftec-grid-2 px-4 pb-2">
                      <selecionar-contato-confirmacao
                        v-if="cliente && cliente.id"
                        :cliente="cliente"
                        v-model="contatoConfirmacao"
                      />
                      <div class="inftec-field">
                        <div class="flex items-center" style="gap: 6px">
                          <span>Possui integração?</span>

                          <vs-icon
                            icon="help_outline"
                            size="16px"
                            title="Marque 'Sim' quando este contrato precisa de técnicos já vinculados para execução. Ao marcar, selecione os técnicos integrados abaixo."
                            color="#ABB7C7"
                            class="cursor-pointer"
                          />
                        </div>
                        <div
                          class="flex items-center"
                          style="gap: 10px; min-height: 38px"
                        >
                          <vs-switch
                            v-model="possuiIntegracao"
                            color="success"
                            :disabled="
                              (!$atividades.permissoes.includes(2) ||
                                contrato.notaExists == 1) &&
                              !$atividades.permissoes.includes(23)
                            "
                          />
                          <span style="font-size: 12px; color: #64748b">
                            {{ possuiIntegracao ? "Sim" : "Não" }}
                          </span>
                          <el-select
                            v-if="possuiIntegracao"
                            v-model="tecnicosIntegradosSelecionados"
                            multiple
                            collapse-tags
                            :disabled="
                              (!$atividades.permissoes.includes(2) ||
                                contrato.notaExists == 1) &&
                              !$atividades.permissoes.includes(23)
                            "
                            :popper-append-to-body="true"
                            class="w-full"
                            clearable
                            filterable
                            placeholder="Selecione os técnicos integrados"
                          >
                            <el-option
                              v-for="tecnico in tecnicosIntegradosOptions"
                              :key="tecnico.id"
                              :label="tecnico.nome"
                              :value="tecnico.id"
                            ></el-option>
                          </el-select>

                          <vs-button
                            v-if="
                              possuiIntegracao &&
                              tecnicosIntegradosSelecionados.length > 0
                            "
                            type="flat"
                            color="danger"
                            size="small"
                            icon="close"
                            class="text-red"
                            @click="limparTecnicosIntegrados"
                            >limpar</vs-button
                          >
                        </div>
                      </div>
                    </div>
                    <div class="inftec-grid-3 px-4">
                      <div class="inftec-field">
                        <label class="">Controle</label>
                        <el-select
                          v-model="contrato.id_controle"
                          v-validate="'required'"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          :popper-append-to-body="true"
                          class="w-full"
                          clearable
                          filterable
                          name="controle"
                          placeholder="Selecione..."
                        >
                          <el-option
                            v-for="controle in controles"
                            :key="controle.id"
                            :label="controle.nome"
                            :value="controle.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="inftec-field">
                        <label class="">Segmento</label>
                        <el-select
                          v-model="contrato.id_segmento"
                          v-validate="'required'"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          :popper-append-to-body="true"
                          class="w-full"
                          clearable
                          filterable
                          name="segmento"
                          placeholder="Selecione..."
                        >
                          <el-option
                            v-for="segmento in segmentos"
                            :key="segmento.id"
                            :label="segmento.nome"
                            :value="segmento.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div class="inftec-field">
                        <label class="">Empresa</label>
                        <el-select
                          v-model="contrato.id_empresa"
                          v-validate="'required'"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          :popper-append-to-body="true"
                          class="w-full"
                          clearable
                          filterable
                          name="empresa"
                          placeholder="Selecione..."
                        >
                          <el-option
                            v-for="empresa in empresas"
                            :key="empresa.id"
                            :label="empresa.razao_social"
                            :value="empresa.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="inftec-grid-2 mt-3 px-4">
                      <div class="inftec-field">
                        <vs-textarea
                          v-model="contrato.obs_tecnica"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          class="w-full"
                          color="dark"
                          counter="255"
                          height="90"
                          label="Observação Técnica"
                        />
                      </div>
                      <div class="inftec-field">
                        <vs-textarea
                          v-model="contrato.obs"
                          :disabled="
                            (!$atividades.permissoes.includes(2) ||
                              contrato.notaExists == 1) &&
                            !$atividades.permissoes.includes(23)
                          "
                          class="w-full"
                          color="dark"
                          counter="255"
                          height="90"
                          label="Observação Geral"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- ═══════════════════ SEÇÃO: EQUIPAMENTOS & ÁREAS ═══════════════════ -->
                  <vs-divider class="py-0 my-0" position="center"
                    >Áreas</vs-divider
                  >
                  <AreasContrato
                    :id="contrato.id"
                    :contrato="contrato"
                    @addAreas="atualizarAreasSelecionadas"
                    @update="updateContrato"
                  />
                </vx-card>
              </div>
            </VuePerfectScrollbar>
          </vs-tab>
          <vs-tab icon="filter_2" label="Pagamento" style="height: 500px">
            <VuePerfectScrollbar
              :settings="settings"
              class="scroll-tab-contrato"
            >
              <div class="tab-general w-full">
                <vx-card>
                  <vs-row vs-type="flex">
                    <vs-col
                      vs-align="flex-start"
                      vs-justify="flex-start"
                      vs-type="flex"
                      vs-w="4"
                    >
                      <h5 style="color: black"></h5>
                    </vs-col>
                    <vs-col
                      vs-align="center"
                      vs-justify="center"
                      vs-type="flex"
                      vs-w="4"
                    >
                      <h4 style="color: black">Informação Financeira</h4>
                    </vs-col>
                    <vs-col
                      vs-align="flex-end"
                      vs-justify="flex-end"
                      vs-type="flex"
                      vs-w="4"
                    >
                      <SuccessButton
                        :disabled="
                          (!$atividades.permissoes.includes(2) ||
                            contrato.notaExists == 1) &&
                          !$atividades.permissoes.includes(23)
                        "
                        class
                        size="small"
                        text="Atualizar"
                        @func="update()"
                      ></SuccessButton>
                    </vs-col>
                  </vs-row>
                  <vs-divider class="pt-5 pb-0 my-0" position="center"
                    >Entrada
                  </vs-divider>
                  <div class="pt-2">
                    <vs-row
                      class="pt-5"
                      vs-align="flex-start"
                      vs-justify="flex-start"
                      vs-type="flex"
                    >
                      <vs-col
                        class="px-3 pb-3"
                        vs-align="center"
                        vs-justify="center"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base w-full">
                          <div class="w-full">
                            <label style="color: black; font-size: 0.85rem"
                              >Tipo de Faturamento</label
                            >
                            <el-select
                              v-model="contrato.id_tipo_faturamento"
                              :disabled="
                                (!$atividades.permissoes.includes(2) ||
                                  contrato.notaExists == 1) &&
                                !$atividades.permissoes.includes(23)
                              "
                              :popper-append-to-body="true"
                              class="w-full"
                              clearable
                              filterable
                              placeholder="Tipo do Faturamento"
                              size
                            >
                              <el-option
                                v-for="tipo in tipos_faturamento"
                                :key="tipo.id"
                                :label="tipo.nome"
                                :value="tipo.id"
                              ></el-option>
                            </el-select>
                          </div>
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            v-model="contrato.entrada"
                            :disabled="
                              (!$atividades.permissoes.includes(2) ||
                                contrato.id_tipo_faturamento == 4 ||
                                contrato.id_tipo_faturamento == 5 ||
                                contrato.notaExists == 1) &&
                              !$atividades.permissoes.includes(23)
                            "
                            color="dark"
                            icon="R$"
                            icon-after="true"
                            label="Entrada"
                            min="1"
                            type="number"
                          />
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <div style="display: inline-block; margin-right: 0px">
                            <label style="color: black; font-size: 13px"
                              >Forma pagamento</label
                            >
                            <br />
                            <el-select
                              v-model="contrato.id_forma_pagamento_entrada"
                              v-validate="'required'"
                              :disabled="
                                (contrato.id_tipo_faturamento == 4 ||
                                  contrato.id_tipo_faturamento == 5 ||
                                  contrato.notaExists == 1) &&
                                !$atividades.permissoes.includes(23)
                              "
                              :popper-append-to-body="true"
                              class="select-info"
                              clearable
                              filterable
                              name="pagamento"
                              placeholder="Selecione..."
                            >
                              <el-option
                                v-for="forma in formasPagamento"
                                :key="forma.id"
                                :label="forma.nome"
                                :value="forma.id"
                                class="select-info"
                              ></el-option>
                            </el-select>
                          </div>
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            v-model="contrato.data_entrada"
                            :disabled="
                              (!$atividades.permissoes.includes(2) ||
                                contrato.id_tipo_faturamento == 4 ||
                                contrato.id_tipo_faturamento == 5 ||
                                contrato.notaExists == 1) &&
                              !$atividades.permissoes.includes(23)
                            "
                            color="dark"
                            label="Data Entrada"
                            min="1"
                            type="date"
                            @input="verificarDataEntrada"
                          />
                        </vx-input-group>
                      </vs-col>
                    </vs-row>
                  </div>
                  <vs-divider class="py-0 my-0" position="center"
                    >Parcela
                  </vs-divider>
                  <div class="pt-2">
                    <vs-row
                      class="pt-5"
                      vs-align="flex-start"
                      vs-justify="flex-start"
                      vs-type="flex"
                    >
                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            v-model="contrato.parcelas"
                            :disabled="
                              (!$atividades.permissoes.includes(2) ||
                                contrato.notaExists == 1) &&
                              !$atividades.permissoes.includes(23)
                            "
                            color="dark"
                            icon="QTD"
                            icon-after="true"
                            label="Parcelas"
                            min="1"
                            type="number"
                          />
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <div style="display: inline-block; margin-right: 0px">
                            <label style="color: black; font-size: 13px"
                              >Forma pagamento</label
                            >
                            <br />
                            <el-select
                              v-model="contrato.id_forma_pagamento_parcela"
                              v-validate="'required'"
                              :disabled="
                                (!$atividades.permissoes.includes(2) ||
                                  contrato.notaExists == 1) &&
                                !$atividades.permissoes.includes(23)
                              "
                              :popper-append-to-body="true"
                              class="select-info"
                              clearable
                              filterable
                              name="forma"
                              placeholder="Selecione..."
                            >
                              <el-option
                                v-for="forma in formasPagamento"
                                :key="forma.id"
                                :label="forma.nome"
                                :value="forma.id"
                                class="select-info"
                              ></el-option>
                            </el-select>
                          </div>
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        class="mr-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            v-model="contrato.intervalo_parcela"
                            :disabled="
                              (!$atividades.permissoes.includes(2) ||
                                contrato.notaExists == 1) &&
                              !$atividades.permissoes.includes(23)
                            "
                            color="dark"
                            icon="DIA"
                            icon-after="true"
                            label="Dias entre pagamentos"
                            min="1"
                            type="number"
                          />
                        </vx-input-group>
                      </vs-col>
                    </vs-row>
                  </div>
                  <vs-divider class="py-0 my-0" position="center"
                    >Total
                  </vs-divider>

                  <!-- DIVISÃO 1 -->
                  <div class="pt-2">
                    <vs-row
                      class="pt-5"
                      vs-align="flex-start"
                      vs-justify="flex-start"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            v-model="contrato.valor_total"
                            :disabled="true"
                            color="dark"
                            icon="R$"
                            icon-after="true"
                            label="Total calculado automáticamente"
                            min="1"
                            type
                          />
                        </vx-input-group>
                      </vs-col>

                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            v-model="contrato.valor"
                            :disabled="
                              contrato.notaExists == 1 &&
                              !$atividades.permissoes.includes(23)
                            "
                            color="dark"
                            icon="R$"
                            icon-after="true"
                            label="Total personalizado"
                            min="1"
                            type
                            @blur="resetManualOverride()"
                            @change="verifyTotal(), setValorComDesconto()"
                          />
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            v-model="contrato.desconto"
                            :disabled="
                              (!$atividades.permissoes.includes(2) ||
                                contrato.notaExists == 1) &&
                              !$atividades.permissoes.includes(23)
                            "
                            :max="
                              limites_desconto.length > 0 &&
                              limites_desconto != undefined &&
                              this.contrato.id_tipo_faturamento > 0
                                ? limites_desconto[
                                    this.contrato.id_tipo_faturamento - 1
                                  ].limite_desconto
                                : 0
                            "
                            color="dark"
                            icon="%"
                            icon-after="true"
                            label="Desconto"
                            min="1"
                            type="number"
                            @change="verifyDesconto(), setValorComDesconto()"
                          />
                        </vx-input-group>
                      </vs-col>

                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            :key="key"
                            v-model="valorComDesconto"
                            color="dark"
                            icon="R$"
                            icon-after="true"
                            label="Total com desconto"
                            min="1"
                            readonly
                            type
                            @change="setValorComDesconto()"
                          />
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        v-if="contrato.id_status == 3"
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <vs-input
                            :key="key"
                            v-model="contrato.valor"
                            color="dark"
                            icon="R$"
                            icon-after="true"
                            label="Valor total - Contrato cancelado"
                            min="1"
                            readonly
                            type
                            @change="setValorComDesconto()"
                          />
                        </vx-input-group>
                      </vs-col>
                    </vs-row>
                  </div>
                  <!-- DIVISÃO  2-->
                  <div class="pt-2">
                    <vs-row
                      class="pt-5"
                      vs-align="flex-start"
                      vs-justify="flex-start"
                      vs-type="flex"
                      vs-w="12"
                    >
                      <vs-col
                        class="mx-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <div
                            style="display: inline-block; margin-right: 20px"
                          >
                            <label style="color: black; font-size: 13px"
                              >Vendedor</label
                            >
                            <br />
                            <el-select
                              v-model="contrato.id_colaborador"
                              :disabled="
                                (!$atividades.permissoes.includes(2) ||
                                  contrato.notaExists == 1) &&
                                !$atividades.permissoes.includes(23)
                              "
                              :popper-append-to-body="true"
                              class="select-info"
                              clearable
                              filterable
                              name="colaborador"
                              placeholder="Selecione..."
                            >
                              <el-option
                                v-for="colaborador in colaboradores"
                                :key="colaborador.id"
                                :label="colaborador.nome"
                                :value="colaborador.id"
                                class="select-info"
                              ></el-option>
                            </el-select>
                          </div>
                        </vx-input-group>
                      </vs-col>
                      <vs-col
                        class="mr-5"
                        vs-align="flex-start"
                        vs-justify="flex-start"
                        vs-type="flex"
                        vs-w="2"
                      >
                        <vx-input-group class="mb-base">
                          <div
                            style="display: inline-block; margin-right: 20px"
                          >
                            <label style="color: black; font-size: 13px"
                              >Orcamentista</label
                            >
                            <br />
                            <el-select
                              v-model="contrato.id_orcamentista"
                              :disabled="
                                (!$atividades.permissoes.includes(2) ||
                                  contrato.notaExists == 1) &&
                                !$atividades.permissoes.includes(23)
                              "
                              :popper-append-to-body="true"
                              class="select-info"
                              clearable
                              filterable
                              name="orcamentista"
                              placeholder="Selecione..."
                            >
                              <el-option
                                v-for="orcamentista in orcamentistas"
                                :key="orcamentista.id"
                                :label="orcamentista.nome"
                                :value="orcamentista.id"
                                class="select-info"
                              ></el-option>
                            </el-select>
                          </div>
                        </vx-input-group>
                      </vs-col>
                    </vs-row>
                  </div>
                </vx-card>
              </div>
            </VuePerfectScrollbar>
          </vs-tab>
          <vs-tab
            :disabled="!(contrato.id_estagio == 3)"
            icon="filter_3"
            label="Faturamento"
            style="height: 800px !important"
          >
            <div
              v-if="contrato.faturado == 1 && validation.validation"
              class="tab-general w-full"
            >
              <listaFaturamento
                :cliente="cliente"
                :contrato="contrato"
                :empresa="empresa_contrato"
                @update="getContrato"
              ></listaFaturamento>
            </div>
            <div v-else class="w-full">
              <validarFaturamento
                :contrato="contrato"
                @getValidacao="getValidacao"
                @update="getContrato"
              />
            </div>
          </vs-tab>

          <vs-tab
            :disabled="!(contrato.id_estagio == 3)"
            icon="filter_4"
            label="Serviços"
            style="height: 500px !important"
          >
            <VuePerfectScrollbar
              :settings="settings"
              class="scroll-tab-contrato"
            >
              <div class="tab-general w-full">
                <vx-card>
                  <Servicos
                    :aplicacoes="contrato.aplicacoes"
                    :cliente="cliente"
                    :contrato="contrato"
                    @update="reRender += 1"
                  ></Servicos>
                </vx-card>
              </div>
            </VuePerfectScrollbar>
          </vs-tab>

          <vs-tab
            :disabled="!(contrato.id_estagio == 3)"
            icon="filter_5"
            label="Dispositivos"
            style="height: 500px !important"
          >
            <VuePerfectScrollbar
              :settings="settings"
              class="scroll-tab-contrato"
            >
              <div class="tab-general w-full">
                <vx-card>
                  <Dispositivos
                    :aplicacoes="contrato.aplicacoes"
                    :cliente="cliente"
                    :contrato="contrato"
                    @update="reRender += 1"
                  ></Dispositivos>
                </vx-card>
              </div>
            </VuePerfectScrollbar>
          </vs-tab>

          <vs-tab icon="filter_6" label="Assuntos" style="height: 500px">
            <div class="tab-general w-full">
              <AssuntoContrato
                :cliente="cliente"
                :contrato="contrato"
              ></AssuntoContrato>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
      <md-speed-dial
        class="md-top-right"
        md-direction="bottom"
        md-event="click"
      >
        <md-speed-dial-target style="background-color: #ffca00" @click="fade()">
          <md-icon style>settings</md-icon>
        </md-speed-dial-target>
        <md-speed-dial-content v-if="fadeClass == 'transparent'">
          <md-button
            class="md-icon-button"
            style="background-color: white"
            @click="ImprimirPdf()"
          >
            <md-icon>print</md-icon>
            <md-tooltip md-direction="right" style="font-size: 15px">
              <Badge color="dark" size="large" text="Imprimir"></Badge>
            </md-tooltip>
          </md-button>
          <md-button
            v-if="contrato.id_status == 3"
            :disabled="!$atividades.permissoes.includes(2)"
            :style="
              $atividades.permissoes.includes(2)
                ? 'background-color: #00BBA2'
                : 'background-color: #aaa'
            "
            class="md-icon-button"
            @click="
              $atividades.permissoes.includes(2) ? showModalRestaurar() : ''
            "
          >
            <md-icon style="color: white">redo</md-icon>
            <md-tooltip md-direction="right" style="font-size: 15px">
              <Badge color="success" size="large" text="Restaurar"></Badge>
            </md-tooltip>
          </md-button>
          <md-button
            v-if="contrato.id_status != 3"
            :disabled="!$atividades.permissoes.includes(3)"
            :style="
              $atividades.permissoes.includes(3)
                ? 'background-color: red'
                : 'background-color: #aaa'
            "
            class="md-icon-button"
            @click="
              $atividades.permissoes.includes(3) ? showModalDeclinar() : ''
            "
          >
            <md-icon>not_interested</md-icon>
            <md-tooltip md-direction="right" style="font-size: 15px">
              <Badge color="red" size="large" text="Declinar"></Badge>
            </md-tooltip>
          </md-button>
          <md-button
            v-if="contrato.id_estagio == 3"
            :disabled="
              (!$atividades.permissoes.includes(2) &&
                !$atividades.permissoes.includes(24)) ||
              (contrato.devendo == 1 && !$atividades.permissoes.includes(24))
            "
            :style="
              ($atividades.permissoes.includes(2) && contrato.devendo != 1) ||
              $atividades.permissoes.includes(24)
                ? 'background-color: #0f4084'
                : 'background-color: #aaa'
            "
            class="md-icon-button"
            @click="
              ($atividades.permissoes.includes(2) && contrato.devendo != 1) ||
              $atividades.permissoes.includes(24)
                ? showModalRenovar()
                : ''
            "
          >
            <md-icon style="color: white">autorenew</md-icon>
            <md-tooltip md-direction="right" style="font-size: 15px">
              <Badge color="#0f4084" size="large" text="Renovar"></Badge>
            </md-tooltip>
          </md-button>
          <md-button
            v-if="contrato.id_estagio == 2"
            :disabled="
              (!$atividades.permissoes.includes(2) || contrato.devendo == 1) &&
              !$atividades.permissoes.includes(24)
            "
            :style="
              ($atividades.permissoes.includes(2) && contrato.devendo != 1) ||
              $atividades.permissoes.includes(24)
                ? 'background-color: #0f4084'
                : 'background-color: #aaa'
            "
            class="md-icon-button"
            @click="
              ($atividades.permissoes.includes(2) && contrato.devendo != 1) ||
              $atividades.permissoes.includes(24)
                ? showModalGerarContrato()
                : ''
            "
          >
            <md-icon style="color: white">list_alt</md-icon>
            <md-tooltip md-direction="right" style="font-size: 15px">
              <Badge color="#021a33" size="large" text="Gerar Contrato"></Badge>
            </md-tooltip>
          </md-button>
          <a
            v-if="contrato.id_estagio == 3"
            :href="'/contas-receber?contrato=' + contrato.id"
          >
            <md-button
              v-if="contrato.id_estagio == 3"
              class="md-icon-button"
              style="background-color: #4a148c"
            >
              <md-icon style="color: white">account_balance</md-icon>
              <md-tooltip md-direction="right" style="font-size: 15px">
                <Badge color="#4a148c" size="large" text="Contas"></Badge>
              </md-tooltip>
            </md-button>
          </a>
          <a
            v-if="contrato.id_estagio == 3"
            :href="'/nota?contrato=' + contrato.id"
          >
            <md-button class="md-icon-button" style="background-color: #4a148c">
              <md-icon style="color: white">receipt</md-icon>
              <md-tooltip md-direction="right" style="font-size: 15px">
                <Badge color="#4a148c" size="large" text="Notas"></Badge>
              </md-tooltip>
            </md-button>
          </a>

          <md-button
            v-if="contrato.id_estagio == 3"
            :disabled="!$atividades.permissoes.includes(4)"
            :style="
              $atividades.permissoes.includes(4)
                ? 'background-color: #ff5733'
                : 'background-color: #aaa'
            "
            class="md-icon-button"
            @click="desfazerContrato"
          >
            <md-icon style="color: white">undo</md-icon>
            <md-tooltip md-direction="right" style="font-size: 15px">
              <Badge
                color="warning"
                size="large"
                text="Desfazer Contrato"
              ></Badge>
            </md-tooltip>
          </md-button>
        </md-speed-dial-content>
      </md-speed-dial>
    </div>

    <component
      v-bind:is="showImprimirPdf"
      :key="reRenderImprimirPdf"
      :cliente="cliente"
      :contrato="contrato"
      :empresa="empresa_contrato"
      :pagamento="formasPagamentoContrato"
      :plano="contrato"
    ></component>
    <component
      v-bind:is="ModalDeclinio"
      :key="reRenderModalDeclinar"
      :contrato="contrato"
      @update="getContratoRerender"
    ></component>
    <component
      v-bind:is="ModalRestaurar"
      :key="reRenderModalRestaurar"
      :contrato="contrato"
      @update="getContratoRerender"
    ></component>
    <component
      v-bind:is="ModalRenovacao"
      :key="reRenderModalRenovacao"
      :contrato="contrato"
      @redirect="contratoRenovado"
    ></component>
    <component
      v-bind:is="ModalGerarContrato"
      :key="reRenderModalGerarContrato"
      :contrato="contrato"
      @update="getContratoRerender"
    ></component>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import ModalEditarCliente from "./../cliente/editar.vue";
import AssuntoContrato from "./components/assuntoContrato.vue";
import AreasContrato from "./components/areas-contrato.vue";
import ImprimirPdf from "./../pdf/pdf.vue";
import planos from "./components/planos.vue";
import declinarModal from "./components/declinarModal";
import restaurarModal from "./components/restaurarModal";
import validarFaturamento from "./components/faturamento/validarFaturamento";
import renovarModal from "./components/renovarModal";
import router from "./../../../router.js";
import gerarContrato from "./components/gerarContrato";
import listaFaturamento from "./components/faturamento/listaFaturamento.vue";
import Servicos from "./components/os/servicos.vue";
import Dispositivos from "./components/os/dispositivos.vue";
import ForcaTrabalho from "./components/forca-trabalho.vue";
import SelecionarContatoConfirmacao from "./components/selecionar-contato-confirmacao.vue";

export default {
  props: {
    client: Object,
    contract: Object,
    address: Object,
    os: Object,
    onlyActives: Boolean,
    onlyPests: Boolean,
  },
  data() {
    return {
      contrato: {},
      endereco: {},
      cliente: {},
      controles: [],
      segmentos: [],
      empresas: [],
      formasPagamento: [],
      colaboradores: [],
      orcamentistas: [],
      key: 0,
      valorComDesconto: null,
      settings: {
        maxScrollbarLength: 160,
        wheelSpeed: 0.6,
        height: 1000,
      },
      ModalDeclinio: null,
      ModalRestaurar: null,
      ModalRenovacao: null,
      ModalGerarContrato: null,
      showImprimirPdf: null,
      reRenderImprimirPdf: 0,
      reRenderModalDeclinar: 0,
      reRenderModalRestaurar: 0,
      reRenderModalRenovacao: 0,
      reRenderModalGerarContrato: 0,
      estagio: null,
      tipo_faturamento: null,
      status: null,
      areasSelecionadas: null,
      fadeClass: "unTransparent",
      reRender: 0,
      empresa_contrato: {},
      empresa: null,
      formasPagamentoContrato: { entrada: null, parcela: null },
      tabs: 0,
      limites_desconto: {},
      tipos_faturamento: {},
      contrato_valor_inicial_total: 0,
      validation: false,
      contatoConfirmacao: null,
      possuiIntegracao: false,
      tecnicosIntegradosSelecionados: [],
      tecnicosIntegradosOptions: [],
    };
  },
  watch: {
    "contrato.valor_total": function (newValue) {
      if (this.updateTriggered) {
        this.contrato.valor = newValue;
      }
    },
    possuiIntegracao(val) {
      if (!val) {
        this.tecnicosIntegradosSelecionados = [];
      }
    },
  },
  created() {
    this.formaPagamentoPadrao();
  },

  computed: {
    valorHoraTecnicaCalculada() {
      const tecnicos_iniciais = this.contrato.tecnicos_iniciais || 0;
      const horas_iniciais = this.contrato.horas_iniciais || 0;
      const tecnicos_manutencao = this.contrato.tecnicos_manutencao || 0;
      const horas_manutencao = this.contrato.horas_manutencao || 0;
      const aplicacoes = this.contrato.aplicacoes || 1;

      // Calcular horas totais
      const totalHoras =
        tecnicos_iniciais * horas_iniciais +
        tecnicos_manutencao * horas_manutencao * (aplicacoes - 1);

      const valorDesconto = parseFloat(this.valorComDesconto) || 0;

      // Calcular valorHoraTecnica
      const valorHora = totalHoras !== 0 ? valorDesconto / totalHoras : 0;

      return valorHora;
    },
    podeEditarContratoFaturado() {
      return (
        this.$atividades &&
        Array.isArray(this.$atividades.permissoes) &&
        this.$atividades.permissoes.includes(23)
      );
    },
    podeDestravarPorLevantamento() {
      return (
        this.$atividades &&
        Array.isArray(this.$atividades.permissoes) &&
        this.$atividades.permissoes.includes(24)
      );
    },
    podeZerarForca() {
      return (
        this.$atividades &&
        Array.isArray(this.$atividades.permissoes) &&
        this.$atividades.permissoes.includes(27)
      );
    },
    isInfoTecnicaDisabled() {
      const permissoes =
        this.$atividades && Array.isArray(this.$atividades.permissoes)
          ? this.$atividades.permissoes
          : [];

      return (
        (!permissoes.includes(2) || this.contrato.notaExists == 1) &&
        !this.podeEditarContratoFaturado
      );
    },
    hasLevantamentoVinculado() {
      return (
        this.contrato.hasLevantamento === true ||
        this.contrato.hasLevantamento === 1 ||
        this.contrato.hasLevantamento === "1"
      );
    },
    isForcaTrabalhoLockedByLevantamento() {
      if (this.podeDestravarPorLevantamento || !this.hasLevantamentoVinculado) {
        return false;
      }

      const camposForcaTrabalho = [
        this.contrato.tecnicos_iniciais,
        this.contrato.horas_iniciais,
        this.contrato.tecnicos_manutencao,
        this.contrato.horas_manutencao,
      ];

      return camposForcaTrabalho.some((value) => this.isCampoPreenchido(value));
    },
  },

  methods: {
    isCampoPreenchido(value) {
      if (value === undefined || value === null) {
        return false;
      }

      if (typeof value === "string") {
        return value.trim() !== "";
      }

      return true;
    },
    formaPagamentoPadrao() {
      this.contrato.id_forma_pagamento_parcela = 4;
      this.contrato.id_forma_pagamento_entrada = 4;
      if (process.env.VUE_APP_FRANCHISING_SIGLA === "itj") {
        this.contrato.id_forma_pagamento_parcela = 4;
      }
      if (process.env.VUE_APP_FRANCHISING_SIGLA === "itj") {
        this.contrato.id_forma_pagamento_entrada = 4;
      }
    },

    async desfazerContrato() {
      const isConfirmed = window.confirm(
        "Tem certeza que deseja desfazer o contrato?",
      );
      if (!isConfirmed) {
        return;
      }
      try {
        const res = await this.$http.put(
          `contrato/desfazer/${this.contrato.id}`,
          {
            id_estagio: 2,
          },
        );
        this.$vs.notify({
          title: "Sucesso",
          text: "Contrato desfeito e revertido para proposta com sucesso",
          color: "success",
        });
        this.getContratoRerender();
      } catch (err) {
        const error = this.$httpErrors(err);
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Ocorreu um erro ao desfazer o contrato.";
        this.$vs.notify({
          title: "Erro",
          text: errorMessage,
          color: "danger",
        });
      }
    },

    // onScrollTecnica(evt) {
    //   if (this._scrollDialogShown) return;
    //   const el = evt && evt.target ? evt.target : null;
    //   if (!el) return;
    //   const atBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 20;
    //   if (atBottom && this.tabs === 0) {
    //     this._scrollDialogShown = true;
    //     this.$vs.dialog({
    //       type: "confirm",
    //       color: "primary",
    //       title: "Próxima etapa",
    //       text: "Deseja ir para a próxima etapa (Pagamento)?",
    //       acceptText: "Sim, ir agora",
    //       cancelText: "Não, continuar aqui",
    //       accept: () => {
    //         this.tabs = 1;
    //         this._scrollDialogShown = false;
    //       },
    //       cancel: () => {
    //         this._scrollDialogShown = false;
    //       },
    //     });
    //   }
    // },

    async fade() {
      if (this.fadeClass == "unTransparent") {
        this.fadeClass = "transparent";
      } else {
        this.fadeClass = "unTransparent";
      }
    },
    async getControles() {
      try {
        this.controles = await this.$http.get("controle");
        await this.$vs.loading.close();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getSegmentos() {
      try {
        this.segmentos = await this.$http.get("segmento");
        await this.$vs.loading.close();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getEmpresas() {
      try {
        this.empresas = await this.$http.get("empresa");
        await this.$vs.loading.close();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getValidacao(validation) {
      this.validation = validation;
    },
    async getFormasPagamento() {
      try {
        this.formasPagamento = await this.$http.get(`formasPagamento`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getTipoFaturamento() {
      try {
        this.tipos_faturamento = await this.$http.get(`tipo_faturamento`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getVendedor() {
      const atividades = [1, 2, 3];
      try {
        this.colaboradores = await this.$http.post(
          `colaboradorAtividade`,
          atividades,
        );
        await this.$vs.loading.close();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getOrcamentistas() {
      const atividades = [11];
      try {
        this.orcamentistas = await this.$http.post(
          `colaboradorAtividade`,
          atividades,
        );
        await this.$vs.loading.close();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getContratoRerender() {
      await this.getContrato();
      await this.getEmpresa();
      this.reRender += await 1;
    },
    async getContratoTab() {
      await this.getContrato();
    },
    async getContrato() {
      try {
        this.contrato = await this.$http.get(
          "getContratoById/" + this.$route.query.id,
        );
        this.possuiIntegracao = Number(this.contrato.possui_integracao) === 1;
        this.tecnicosIntegradosSelecionados = this.parseTecnicosIntegrados(
          this.contrato.tecnicos_integrados,
        );
        this.status = this.contrato.status;
        this.estagio = this.contrato.estagio;
        this.tipo_faturamento = this.contrato.tipo_faturamento;
        // Inicializa contatoConfirmacao se o contrato já tem um definido
        if (this.contrato.id_contato_confirmacao) {
          // Busca o contato pelo id para preencher o componente de seleção
          try {
            const contatos = await this.$http.get(
              "contatoCliente/" + this.contrato.id_cliente,
            );
            const encontrado = contatos.find(
              (c) => c.id == this.contrato.id_contato_confirmacao,
            );
            if (encontrado) this.contatoConfirmacao = encontrado;
          } catch (e) {
            // silencioso
          }
        } else {
          this.contatoConfirmacao = null;
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getCliente() {
      try {
        this.cliente = await this.$http.get(
          "cliente/" + this.contrato.id_cliente,
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async contratoRenovado(id) {
      await router.push("/contrato?id=" + id);
    },

    async update() {
      await this.$vs.loading();
      await this.setValorComDesconto();
      // Armazena o valor anterior do desconto
      const descontoAnterior = this.contrato.desconto;

      delete this.contrato.notaExists;
      delete this.contrato.have2Bill;
      delete this.contrato.estagio;
      delete this.contrato.tipo_faturamento;
      delete this.contrato.status;
      delete this.contrato.controle;
      delete this.contrato.obs_tipo_faturamento;
      delete this.contrato.forma_pagamento;
      delete this.contrato.data_documento;
      delete this.contrato.vencimento;
      delete this.contrato.devendo;
      delete this.contrato.contrato_parcelas_atrasadas;
      delete this.contrato.hasLevantamento;

      // Salva o contato de confirmação selecionado
      this.contrato.id_contato_confirmacao = this.contatoConfirmacao
        ? this.contatoConfirmacao.id
        : null;
      this.contrato.possui_integracao = this.possuiIntegracao ? 1 : 0;
      this.contrato.tecnicos_integrados = this.possuiIntegracao
        ? JSON.stringify(this.tecnicosIntegradosSelecionados)
        : null;

      // Atualize o campo valor apenas ao clicar no botão
      this.updateTriggered = true; // Marcar que a atualização foi acionada pelo usuário
      if (!this.contrato.valor || this.contrato.valor === 0) {
        this.contrato.valor = this.contrato.valor_total;
      }

      try {
        if (
          Array.isArray(this.areasSelecionadas) &&
          this.areasSelecionadas.length >= 0
        ) {
          await this.postAreas();
        }

        console.log(
          "🚀 PAYLOAD CONTRATO:",
          JSON.stringify(this.contrato, null, 2),
        );

        const res = await this.$http.put(
          "contrato/" + this.$route.query.id,
          this.contrato,
        );

        await this.$vs.notify({
          title: "Sucesso",
          text: "Informações Atualizadas com Sucesso",
          color: "success",
        });

        await this.getContratoRerender();
      } catch (err) {
        const error = this.$httpErrors(err);

        if (error && error.response && error.response.status === 400) {
          const message =
            error.response.data.message || "Erro ao atualizar contrato.";

          // Restaura o desconto para o valor anterior
          this.contrato.desconto = descontoAnterior;

          await this.$vs.notify({
            title: "Erro",
            text: message,
            color: "danger",
          });
        } else {
          // Notifica erros gerais
          await this.$vs.notify({
            title: "Erro ao atualizar",
            text: "Ocorreu um erro ao atualizar o contrato.",
            color: "danger",
          });
        }

        if (error.code === 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close();
      }
    },

    async showModalDeclinar() {
      this.ModalDeclinio = "declinarModal";
      this.reRenderModalDeclinar = this.reRenderModalDeclinar + 1;
    },
    async showModalRestaurar() {
      this.ModalRestaurar = "restaurarModal";
      this.reRenderModalRestaurar = this.reRenderModalRestaurar + 1;
    },
    async showModalRenovar() {
      this.ModalRenovacao = "renovarModal";
      this.reRenderModalRenovacao = this.reRenderModalRenovacao + 1;
    },
    async showModalGerarContrato() {
      this.ModalGerarContrato = "gerarContrato";
      this.reRenderModalGerarContrato = this.reRenderModalGerarContrato + 1;
    },
    async ImprimirPdf() {
      if (
        this.contrato.parcelas > 0 &&
        this.contrato.id_forma_pagamento_parcela > 0
      ) {
        this.formasPagamentoContrato.parcela = this.formasPagamento.find(
          (x) => x.id == this.contrato.id_forma_pagamento_parcela,
        ).nome;
      }
      if (
        this.contrato.entrada > 0 &&
        this.contrato.id_forma_pagamento_entrada > 0
      ) {
        this.formasPagamentoContrato.entrada = this.formasPagamento.find(
          (x) => x.id == this.contrato.id_forma_pagamento_entrada,
        ).nome;
      }
      this.showImprimirPdf = "ImprimirPdf";
      this.reRenderImprimirPdf = this.reRenderImprimirPdf + 1;
    },
    async atualizarAreasSelecionadas(areasSelecionadas) {
      this.areasSelecionadas = areasSelecionadas;
    },
    async getLimitesDesconto() {
      try {
        this.limites_desconto = await this.$http.get("limites_desconto");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async verifyDesconto() {
      if (this.$atividades.permissoes.includes(23)) {
        if (
          this.limites_desconto[this.contrato.id_tipo_faturamento - 1]
            .limite_desconto < this.contrato.desconto
        ) {
          this.contrato.desconto =
            this.limites_desconto[
              this.contrato.id_tipo_faturamento - 1
            ].limite_desconto;

          this.$vs.notify({
            title: "Desconto inválido!",
            text: "O desconto dado é maior que o limite deste tipo de faturamento!",
            color: "danger",
          });
        }
      }
    },

    async postAreas() {
      delete this.contrato.notaExists;
      delete this.contrato.estagio;
      delete this.contrato.tipo_faturamento;
      delete this.contrato.status;
      try {
        await this.$http.post("contrato_areas", {
          id_contrato: this.contrato.id,
          areas: this.areasSelecionadas,
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async updateContrato(contrato) {
      if (contrato) {
        this.contrato = contrato;
      }
    },
    async verifyTotal() {
      if (this.$atividades.permissoes.includes(23)) {
        if (this.contrato.valor < this.contrato_valor_inicial_total) {
          this.contrato.valor = this.contrato_valor_inicial_total;
          this.$vs.notify({
            title: "Valor total inválido!",
            text: "O valor total só aceita incremento!",
            color: "danger",
          });
        } else {
          this.manualOverride = true;
        }
      }
    },

    resetManualOverride() {
      this.manualOverride = false;
    },

    async verificarDataEntrada(event) {
      const dataEntrada = new Date(event).getTime();
      let dataDocumento = new Date(this.contrato.data_proposta).getTime();
      if (this.contrato.id_estagio == 3) {
        dataDocumento = new Date(this.contrato.data_contrato).getTime();
      }
      if (dataEntrada < dataDocumento) {
        this.$vs.notify({
          title: "Data de Entrada Inválida",
          text: "Data da entrada não pode ser menor que a data do documento!",
          color: "danger",
        });
        this.contrato.data_entrada = null;
      }
    },
    async getEmpresa() {
      try {
        this.empresa_contrato = await this.$http.get(
          `empresa/` + this.contrato.id_empresa,
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async setValorComDesconto() {
      if (this.contrato.desconto != 0) {
        this.valorComDesconto =
          this.contrato.valor -
          this.contrato.valor * (this.contrato.desconto / 100);
      } else {
        this.valorComDesconto = this.contrato.valor;
      }
      if (this.contrato.desconto == 0) {
        this.valorComDesconto = this.contrato.valor;
      }
      this.key++;
    },
    parseTecnicosIntegrados(value) {
      if (Array.isArray(value)) {
        return value.map(Number).filter((id) => !Number.isNaN(id));
      }

      if (typeof value === "string" && value.trim() !== "") {
        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) {
            return parsed.map(Number).filter((id) => !Number.isNaN(id));
          }
        } catch (e) {
          console.error("Erro ao converter tecnicos_integrados", e);
          return [];
        }
      }

      return [];
    },
    limparTecnicosIntegrados() {
      this.tecnicosIntegradosSelecionados = [];
    },
    async getTecnicosIntegradosOptions() {
      try {
        this.tecnicosIntegradosOptions = await this.$http.post(
          "colaboradorAtividade",
          [10],
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      }
    },
    async getEnderecosParaAssociar() {
      try {
        this.enderecos = await this.$http.post("getEnderecosParaAssociar", {
          id_cliente: this.contrato.id_cliente,
          id_contrato: this.contrato.id,
        });
        await this.enderecos.map(async function (x) {
          return (await x.servicos) > 0
            ? (x, (x.nulo = false))
            : ((x.servicos = 0), (x.nulo = true));
        });
        this.calServicosAssociados(this.enderecos);
        this.reRender += 1;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.reRenderButtons += await 1;
      }
    },
  },

  components: {
    ...components,
    ModalEditarCliente,
    AssuntoContrato,
    planos,
    declinarModal,
    restaurarModal,
    renovarModal,
    gerarContrato,
    validarFaturamento,
    AreasContrato,
    ForcaTrabalho,
    SelecionarContatoConfirmacao,
    ImprimirPdf,
    listaFaturamento,
    Servicos,
    Dispositivos,
  },
  async mounted() {
    await this.$vs.loading();
    await this.getContratoRerender();
    await this.getEmpresa();
    await this.getCliente();
    await this.getControles();
    await this.getLimitesDesconto();
    await this.getFormasPagamento();
    await this.getVendedor();
    await this.getOrcamentistas();
    await this.getSegmentos();
    await this.getEmpresas();
    await this.getTipoFaturamento();
    await this.getTecnicosIntegradosOptions();
    await this.setValorComDesconto();
    await this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
.transparent {
  opacity: 0.3;
  transition-duration: 300ms;
}

.unTransparent {
  opacity: 1;
  transition-duration: 300ms;
}

.con-slot-tabs {
  width: 100%;
}

.con-tab-ejemplo {
  width: 100%;
}

.vs-list--item .list-titles .vs-list--subtitle {
  font-size: 1.3rem;
}

.el-tabs__item.is-active {
  color: #ffca00 !important;
}

.el-tabs__item:hover {
  color: #ffca00 !important;
}

.el-tabs__active-bar {
  background-color: #ffca00 !important;
}

.col {
  width: auto;
}

.vs-tabs--content {
  padding: 0;
}

.input-group-prepend {
  color: #ffca00 !important;
}

.bootstrap-button {
  background-color: #ffca00 !important;
  color: black !important;
  cursor: default !important;
}

.scroll-tab-contrato {
  height: 500px !important;
}

#icons-contrato {
  .vs-icon-dark {
    font-size: 20px !important;
  }
}

/* ═══════════ Inf. Técnica - Layout Grid ═══════════ */

.inftec-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 2px solid #f1f5f9;
  margin-bottom: 4px;
}

.inftec-header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.inftec-header-title h4 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}

.inftec-icon {
  font-size: 20px;
}

/* ── Força de Trabalho layout ── */
.forca-trabalho-layout {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.forca-inputs-col {
  flex: 1;
  min-width: 0;
}

.forca-inputs-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.forca-divider-vertical {
  width: 1px;
  background: #e2e8f0;
  align-self: stretch;
  margin: 0 4px;
}

.forca-switches-col {
  flex: 0 0 auto;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (max-width: 768px) {
  .forca-trabalho-layout {
    flex-direction: column;
  }
  .forca-divider-vertical {
    display: none;
  }
  .forca-switches-col {
    min-width: 0;
    width: 100%;
  }
}

.inftec-grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding-bottom: 8px;
}

.inftec-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.inftec-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.inftec-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

// /* Responsivo */
// @media (max-width: 960px) {
//   .inftec-grid-4 {
//     grid-template-columns: repeat(2, 1fr);
//   }
//   .inftec-grid-3 {
//     grid-template-columns: repeat(2, 1fr);
//   }
//   .inftec-grid-2 {
//     grid-template-columns: 1fr;
//   }
// }

// @media (max-width: 600px) {
//   .inftec-grid-4,
//   .inftec-grid-3,
//   .inftec-grid-2 {
//     grid-template-columns: 1fr;
//   }
// }
</style>
